import { useEffect, useState } from "react";
import ButtonOutlineSmall from "../../components/Button/ButtonOutlineSmall";
import ButtonSolidSmall from "../../components/Button/ButtonSolidSmall";
import ButtonDropdown from "../../components/ButtonDropdown/ButtonDropdown";
import ChipSuggest32 from "../../components/Chip/ChipSuggest32";
import { useSelector } from "react-redux";
import i18next from "i18next";

const ButtonDropdownMaterial = ({
  id,
  materialFilter,
  setMaterialFilter,
  showButton,
}) => {
  const { dataProductCategory } = useSelector(
    (state) => state.dataProductCategory
  );

  const [tempMaterial, setTempMaterial] = useState([]);

  const closeModal = () => {
    const dropdown = document.getElementById(id + "Dropdown-Container");

    if (dropdown) {
      dropdown.classList.remove("show");
      dropdown.classList.add("hidden");
    }
  };

  useEffect(() => {
    setTempMaterial([...materialFilter]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materialFilter]);

  return (
    <ButtonDropdown
      isHidden={true}
      title={i18next.t("filter.material")}
      badge={materialFilter?.length ? materialFilter?.length : undefined}
      id={id}
      container={
        <div className="material--filter--container">
          <div className="material--filter--container-content">
            {dataProductCategory?.materialFilter?.map((material, i) => (
              <ChipSuggest32
                key={i}
                title={material?.title}
                onClick={() => {
                  const newMaterial = showButton
                    ? tempMaterial
                    : materialFilter;
                  const index = newMaterial?.findIndex(
                    (id) => id === material._id
                  );
                  if (index > -1) {
                    newMaterial.splice(index, 1);
                  } else newMaterial.push(material?._id);
                  if (showButton) setTempMaterial([...newMaterial]);
                  else setMaterialFilter([...newMaterial]);
                }}
                isSelected={tempMaterial?.includes(material?._id)}
              />
            ))}
          </div>
          {showButton && (
            <div className="material--filter--container-button">
              <ButtonOutlineSmall
                title={i18next.t("filter.button.close")}
                type={"button"}
                onClick={() => {
                  closeModal();
                  setMaterialFilter(undefined);
                }}
              />
              <ButtonSolidSmall
                title={i18next.t("filter.button.apply")}
                type={"button"}
                onClick={() => {
                  closeModal();
                  setMaterialFilter(tempMaterial);
                }}
              />
            </div>
          )}
        </div>
      }
    />
  );
};

export default ButtonDropdownMaterial;
